export default __webpack_public_path__ + "static/media/bunnyButton.22abef62.png";